import { Group } from '@gripp/shared-logic';
import { colors, GroupSelector, tokens } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { CopyRoutinesToWorkspace } from './copyRoutinesToWorkspace';
import { DownloadRoutineWithDateFilter } from './downloadRoutineWithDateFilter';

type Props = {
  routineIds: string[];
  workspaceId: string;
  selectedGroups: Group[];
  onGroupsChange: (groups: Group[]) => void;
  onCreateGroup: (name: string) => Promise<Group>;
  onOpenPicker: () => void;
};

/**
 * Main body of the routines selection side panel. Mirrors the People panel:
 * Groups editor (chips + `+`) inline, with a dedicated picker mounted as a
 * thirdColumn when the user taps `+`. Download / Copy-to-Workspace bulk
 * actions remain as-is.
 */
export const RoutinesSelectionPanelMain = ({
  routineIds,
  workspaceId,
  selectedGroups,
  onGroupsChange,
  onCreateGroup,
  onOpenPicker,
}: Props) => {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Text style={[tokens.typography.label.largeEmphasised, styles.label]}>
        {t('asset.groups')}
      </Text>
      <GroupSelector
        selectedGroups={selectedGroups}
        availableGroups={[]}
        onGroupsChange={onGroupsChange}
        onCreateGroup={onCreateGroup}
        useCropCircle
        onSelectorEdit={onOpenPicker}
      />

      <DownloadRoutineWithDateFilter
        label={t('routines.menu.download')}
        routineIds={routineIds}
        workspaceId={workspaceId}
      />
      <CopyRoutinesToWorkspace
        routineIds={routineIds}
        workspaceId={workspaceId}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 12,
  },
  label: {
    color: colors.brand.black,
  },
});
